import { z } from 'zod';
import { baseCustomFieldSchema } from '@/features/dashboard/tourCustomFields/schemas/baseCustomFieldSchema.ts';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';

export const textCustomFieldSchema = baseCustomFieldSchema.extend({
  type: z.literal(FieldType.TEXT),
  placeholder: z
    .string()
    .max(255, 'Maksymalna długość placeholdera to 255 znaków'),
  isCharacterLimitEnabled: z.boolean({ error: 'Pole wymagene' }),
  minChars: z
    .int({ error: 'Limit znaków musi być liczbą całkowitą' })
    .nonnegative('Limit znaków musi być większy od lub równy 0')
    .optional(),
  maxChars: z
    .int({ error: 'Limit znaków musi być liczbą całkowitą' })
    .max(1000, 'Limit znaków musi być mniejszy lub równy 1000')
    .positive('Limit znaków musi być większy od 0')
    .optional(),
});

export type TextCustomFieldInputData = z.input<typeof textCustomFieldSchema>;
export type TextCustomFieldFormData = z.infer<typeof textCustomFieldSchema>;
